import React, { useEffect } from 'react';
/**
 * On IOS devices the modal close button overlaps
 * the close button of DropdownHolder due to sticky nature.
 *
 * Maybe a better approach should be found.
 */
export const useCloseMobMenuModalButtonToggler = ({ dropdownOpen }) => {
    useEffect(() => {
        const closeMobMenuModalButton = document.querySelector(
            '[datatype^="scroll-position"] > button'
        );

        if (!closeMobMenuModalButton) return;

        closeMobMenuModalButton.style.display = dropdownOpen ? 'none' : '';
    }, [dropdownOpen]);
};
